// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --thm-primary: #1b2b5a;
  --thm-secondary: #40b7f7;
}
#root {
  background-color: #fff;
}

.css-jg1ckv {
  display: block;
  height: auto;
}
.css-yibgmg {
  background-color: transparent;
}
.css-y12xsv {
  background-color: transparent;
}
.MuiTablePagination-selectLabel.css-pdct74-MuiTablePagination-selectLabel,
.MuiTablePagination-displayedRows.css-levciy-MuiTablePagination-displayedRows {
  margin-top: 15px;
}

.payment-modal
  .MuiInputLabel-root.MuiInputLabel-formControl.MuiInputLabel-animated.MuiInputLabel-outlined.MuiFormLabel-root.MuiFormLabel-colorPrimary {
  background-color: white;
}
.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation24.MuiDialog-paper.MuiDialog-paperScrollPaper.MuiDialog-paperWidthSm.css-1s305u7-MuiPaper-root-MuiDialog-paper {
  width: 100%;
}
.payment-modal
  .MuiFormControlLabel-root.MuiFormControlLabel-labelPlacementEnd.css-j204z7-MuiFormControlLabel-root {
  margin-right: 0px;
}

.MyCustomButton:hover {
  background-color: transparent !important;
}

.css-1x8weih-MuiPaper-root-MuiCard-root {
  overflow-x: auto;
}
.MuiBox-root.css-1frum38 {
  overflow-x: hidden;
}

.header-primary {
  color: var(--thm-primary);
}

.paragraph-primary {
  color: var(--thm-primary);
  font-weight: normal;
  font-size: 14px;
}

.app-bar .user-control a span {
  color: #fff;
}
.app-bar .user-control a span:hover {
  color: #35a2db;
}

.react-pagination-js-default ul li.page,
.react-pagination-js-default ul li.is-active {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  text-align: center;
  color: #121e3e;
  line-height: 38px;
  background: transparent;
}

.react-pagination-js-default ul li.is-active {
  background: #121e3e;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb","sourcesContent":[":root {\r\n  --thm-primary: #1b2b5a;\r\n  --thm-secondary: #40b7f7;\r\n}\r\n#root {\r\n  background-color: #fff;\r\n}\r\n\r\n.css-jg1ckv {\r\n  display: block;\r\n  height: auto;\r\n}\r\n.css-yibgmg {\r\n  background-color: transparent;\r\n}\r\n.css-y12xsv {\r\n  background-color: transparent;\r\n}\r\n.MuiTablePagination-selectLabel.css-pdct74-MuiTablePagination-selectLabel,\r\n.MuiTablePagination-displayedRows.css-levciy-MuiTablePagination-displayedRows {\r\n  margin-top: 15px;\r\n}\r\n\r\n.payment-modal\r\n  .MuiInputLabel-root.MuiInputLabel-formControl.MuiInputLabel-animated.MuiInputLabel-outlined.MuiFormLabel-root.MuiFormLabel-colorPrimary {\r\n  background-color: white;\r\n}\r\n.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation24.MuiDialog-paper.MuiDialog-paperScrollPaper.MuiDialog-paperWidthSm.css-1s305u7-MuiPaper-root-MuiDialog-paper {\r\n  width: 100%;\r\n}\r\n.payment-modal\r\n  .MuiFormControlLabel-root.MuiFormControlLabel-labelPlacementEnd.css-j204z7-MuiFormControlLabel-root {\r\n  margin-right: 0px;\r\n}\r\n\r\n.MyCustomButton:hover {\r\n  background-color: transparent !important;\r\n}\r\n\r\n.css-1x8weih-MuiPaper-root-MuiCard-root {\r\n  overflow-x: auto;\r\n}\r\n.MuiBox-root.css-1frum38 {\r\n  overflow-x: hidden;\r\n}\r\n\r\n.header-primary {\r\n  color: var(--thm-primary);\r\n}\r\n\r\n.paragraph-primary {\r\n  color: var(--thm-primary);\r\n  font-weight: normal;\r\n  font-size: 14px;\r\n}\r\n\r\n.app-bar .user-control a span {\r\n  color: #fff;\r\n}\r\n.app-bar .user-control a span:hover {\r\n  color: #35a2db;\r\n}\r\n\r\n.react-pagination-js-default ul li.page,\r\n.react-pagination-js-default ul li.is-active {\r\n  width: 38px;\r\n  height: 38px;\r\n  border-radius: 50%;\r\n  text-align: center;\r\n  color: #121e3e;\r\n  line-height: 38px;\r\n  background: transparent;\r\n}\r\n\r\n.react-pagination-js-default ul li.is-active {\r\n  background: #121e3e;\r\n  color: #fff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
